import { FC } from 'react';
import { DesignCsvData } from '../../types';
import { useDesign } from '../../hooks';
import { ItemDropdown, ItemDropdownPropsWithoutItems } from '../../form_components';

export type CsvDropdownProps = ItemDropdownPropsWithoutItems<DesignCsvData, string>;

/** Select a @see DesignCsvData from a @see Design. */
export const CsvDropdown: FC<CsvDropdownProps> = (baseProps) => {
  const serialized = useDesign();

  return (
    <ItemDropdown
      {...baseProps}
      items={serialized.csvData}
      labels={{
        noOptions: 'No CSVs in the design.',
        placeholder: 'Select CSV from design.',
        ...baseProps.labels
      }}
    />
  );
};
